import { VerificationStatus } from "../api/AnalysisStep";
import { AnomalyLevel } from "../components/ui/pill/AnomalyPill"; 

export const calculateCommonVerificationAnomaly = (currentStatus?: VerificationStatus | null): AnomalyLevel => {
  if (!currentStatus) {
    return AnomalyLevel.NO_ANOMALY;
  }
  
  switch (currentStatus) {
    case VerificationStatus.NEGATIVE:
      return AnomalyLevel.CRITICAL;
    case VerificationStatus.POSITIVE: 
      return AnomalyLevel.NO_ANOMALY;
    case VerificationStatus.WAIVED:
      return AnomalyLevel.MODERATE;
    case VerificationStatus.NOT_AVAILABLE:
      return AnomalyLevel.NO_ANOMALY;
    default:
      return AnomalyLevel.NO_ANOMALY; // Default fallback
  }
};


export const calculateValuationAnomaly = (
  currentValuation?: number | null, 
  preLoginValuation?: number | null
): AnomalyLevel => {
  // Handle edge cases
  if (!currentValuation || !preLoginValuation || preLoginValuation <= 0) {
    return AnomalyLevel.NO_ANOMALY; // Default to no anomaly for invalid data
  }

  // Calculate percentage of pre-login valuation
  const percentageOfPreLogin = (currentValuation / preLoginValuation) * 100;
  
  console.log(`💰 Valuation Anomaly Calculation:`, {
    currentValuation,
    preLoginValuation,
    percentageOfPreLogin: Math.round(percentageOfPreLogin * 100) / 100, // Round to 2 decimal places
  });


  if (percentageOfPreLogin > 90) {
    return AnomalyLevel.NO_ANOMALY;
  } else if (percentageOfPreLogin >= 65) {
    return AnomalyLevel.MODERATE;
  } else {
    return AnomalyLevel.CRITICAL;
  }
};

/**
 * Helper function to format percentage for display
 */
export const getValuationPercentage = (
  currentValuation: number, 
  preLoginValuation: number
): string => {
  if (!currentValuation || !preLoginValuation || preLoginValuation <= 0) {
    return 'N/A';
  }
  
  const percentage = (currentValuation / preLoginValuation) * 100;
  return `${Math.round(percentage)}%`;
};
